
import { computed, defineComponent, PropType, Ref } from 'vue';
import { Form } from 'vee-validate';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import WebApiMessage from '@/core/http/WebApiMessage.vue';
import { B2CMyBoliaProfileAddress } from '@/b2c/shared/api/server-apis';
import profileStore, { B2CProfileEditMode } from '@/b2c/profile/profile.store';
import { Country } from '@/types/B2CcontentServerContract';
import ProfileInfoItem from '@/b2c/profile/ui/ProfileInfoItem.vue';

export const editProfileAddressWebApiMessageKey = 'editProfileAddressApiMessages';

export default defineComponent({
    name: 'ProfileAddress',
    components: { ProfileInfoItem, WebApiMessage, Form },
    props: {
        countries: {
            type: Array as PropType<Country[]>,
            required: true,
        },
    },
    setup(props) {
        const labels = useBlockLabels();
        const editMode: Ref<boolean> = computed(() => profileStore.isAddressEditMode);
        const address: Ref<B2CMyBoliaProfileAddress> = computed(() => profileStore.address);
        const getDefaultEditValues = (): B2CMyBoliaProfileAddress => ({ ...address.value });

        const submit = async(address: B2CMyBoliaProfileAddress): Promise<void> => {
            const addressWithCountry = {
                ...address,
                country: props.countries.find(c => c.code === address.countryCode)?.name,
            };
            await profileStore.updateProfileAddress(addressWithCountry, editProfileAddressWebApiMessageKey);
            clearEditMode();
        };

        const setEditMode = (): void => {
            profileStore.setEditMode(B2CProfileEditMode.Address);
        };

        const clearEditMode = (): void => {
            profileStore.clearEditMode();
        };

        const formValidation = {
            street: 'required',
            zip: 'required',
            city: 'required',
            countryCode: 'required',
            phone: 'required|phone',
            alternativePhone: 'phone',
        };

        return {
            labels,
            address,
            submit,
            formValidation,
            getDefaultEditValues,
            editProfileAddressWebApiMessageKey,
            editMode,
            setEditMode,
            clearEditMode,
        };
    },
});
